import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import LinkBack from '../widgets/LinkBack';
import Typography from '../widgets/Typography/Typography';
import InvestorsTabs from './InvestorsTabs';

import './investors.scss';

class InvestorsTemplate extends PureComponent {
  render() {
    const { meta, info, general, bonds } = this.props.content;
    const files = this.props.files;
    const presentation =
      files.presentation && files.presentation.items
        ? files.presentation.items[0]
        : null;
    return (
      <div className="investors">
        {meta && (
          <Helmet>
            <title>{meta.title}</title>
          </Helmet>
        )}

        <div className="container">
          <div className="investors-content">
            {/* <LinkBack link="/we/subnavigation/">
              мы <i>вернуться</i>
            </LinkBack> */}
            <div className="investors-about subnavigation-info">
              <Typography content={info} />
              {presentation && (
                <a
                  href={presentation.link}
                  className="btn btn-arrowed"
                  target="_blank"
                >
                  <span>→</span>Презентация инвесторам
                </a>
              )}
              <a
                href="https://www.e-disclosure.ru/portal/company.aspx?id=37308"
                className="btn btn-arrowed"
                target="_blank"
              >
                <span>→</span>Адрес раскрытия информации
              </a>
            </div>
            <div className="investors-tabs">
              <InvestorsTabs files={files} general={general} bonds={bonds} />
            </div>
            <div className='typography'>
              <p> ООО «ЮСК Девелопмент» использует файлы "cookie"
                с целью персонализации сервисов и повышения удобства пользования сайтом.
                Если вы не хотите, чтобы ваши пользовательские данные обрабатывались, пожалуйста,
                ограничьте их использование в своём браузере. <a class="content-link"
                  href="https://uscapital.ru/media/content_files/Политика_использования_файлов_cookie.pdf">
                  Политика использования файлов cookie.</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InvestorsTemplate.propTypes = {
  content: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string
    }),
    info: PropTypes.arrayOf(PropTypes.object),
    general: PropTypes.arrayOf(PropTypes.object),
    bonds: PropTypes.arrayOf(PropTypes.object)
  })
};

export default InvestorsTemplate;



// WEBPACK FOOTER //
// ./src/components/Investors/InvestorsTemplate.js